import { render, staticRenderFns } from "./KPIHeader.vue?vue&type=template&id=766f835a&scoped=true"
import script from "./KPIHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KPIHeader.vue?vue&type=style&index=0&id=766f835a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f835a",
  null
  
)

export default component.exports